export enum TimeIntervalUnit {
	Days = 'days',
	Weeks = 'weeks',
	Months = 'months',
	Years = 'years',
}
